import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { useMessageMediaAccessQuery } from './useMessageMediaAccessQuery';
import MediaActionsMenu from './MediaActionsMenu';

const VideoMessageContent = ({ media, messageUuid }) => {
  const isReady = media?.status === 'ready';
  const { data, isLoading, isError } = useMessageMediaAccessQuery(messageUuid, Boolean(messageUuid) && isReady);
  const videoUrl = data?.url ?? media?.signedUrl;

  if (videoUrl) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
        <Box
          component="video"
          controls
          preload="metadata"
          sx={{
            display: 'block',
            maxWidth: { xs: '100%', sm: 320 },
            maxHeight: 360,
            width: 'auto',
            height: 'auto',
            borderRadius: 1,
          }}
        >
          <source src={videoUrl} type={media?.mimeType || undefined} />
          Your browser does not support video playback.
        </Box>
        <MediaActionsMenu url={videoUrl} filename={media?.filename} />
      </Box>
    );
  }

  if (media?.status === 'failed' || isError) {
    return <Typography variant="body2">Nao foi possivel carregar o video.</Typography>;
  }

  // Anything other than 'ready' (null, 'pending', 'processing') means the
  // media service hasn't finished yet — keep the skeleton until it has.
  if (!isReady || isLoading) {
    return <Skeleton variant="rounded" width={240} height={180} />;
  }

  return <Typography variant="body2">Video indisponivel.</Typography>;
};

export default VideoMessageContent;
